import React from 'react';
import { FaWhatsapp, FaPlay } from 'react-icons/fa';
import { FaFacebook, FaGoogle } from 'react-icons/fa6';
import { HiOutlineChatBubbleLeftRight } from 'react-icons/hi2';
import { LuChartBar, LuTrendingUp, LuArrowUpRight, LuArrowDownRight, LuTag } from 'react-icons/lu';
import { MdAttachMoney } from 'react-icons/md';
// Konstanta WhatsApp
const WA_NUMBER = '6282337289588';
const WA_MESSAGE = 'Halo%20SriDesain%2C%20saya%20tertarik%20untuk%20konsultasi%20digital%20marketing';


function LogoMark({ className = '' }) {
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none">
      <path d="M24 2 L44 12 V24 C44 35 36 42 24 46 C12 42 4 35 4 24 V12 Z" fill="#C9A227" />
      <path
        d="M17 16 h14 a5 5 0 0 1 0 10 h-8 a5 5 0 0 0 0 10 h14"
        stroke="#0F172A"
        strokeWidth="3.2"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}

function StatCard({ className, children }) {
  return (
    <div
      className={`absolute rounded-xl border border-slate-100/80 bg-white/90 backdrop-blur-sm shadow-lg shadow-slate-200/50 ${className}`}
    >
      {children}
    </div>
  );
}

const Section1 = () => {
    // Fungsi untuk scroll ke section case study
  const scrollToCaseStudy = () => {
    const element = document.getElementById('case-study');
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return (
    <section className="relative overflow-hidden bg-white lg:h-screen">
      {/* Ambient glow */}
      <div className="pointer-events-none absolute -top-40 right-0 h-[600px] w-[600px] rounded-full bg-amber-100/60 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-1/3 h-[400px] w-[400px] rounded-full bg-slate-100/70 blur-3xl" />

      <div className="relative mx-auto flex h-full max-w-7xl flex-col px-6 py-6 lg:justify-center lg:px-10 lg:py-4">
       {/* Logo */}
        <div className="flex items-center gap-2.5">
          <img 
            src="/logo.jpeg" 
            alt="SriDesain Logo"
            className="h-12 w-12 object-contain"
          />
          <div>
            <p className="font-[var(--font-display)] text-base font-bold leading-none text-[#0F172A]">
              SriDesain
            </p>
            <p className="mt-1 text-[11px] text-slate-500">
              Terima Beres Digital Marketing Partner
            </p>
          </div>
        </div>

        {/* Main grid */}
        <div className="mt-6 grid grid-cols-1 items-center gap-10 lg:mt-8 lg:grid-cols-2 lg:gap-8">
          {/* Left: copy */}
          <div>
            <h1 className="font-[var(--font-display)] text-2xl font-bold leading-[1.15] tracking-tight text-[#0F172A] sm:text-3xl xl:text-4xl">
              Tingkatkan Omzet &amp;{' '}
              <span className="text-amber-600">Keuntungan Bisnis Anda</span>{' '}
              dengan Strategi Iklan yang Terbukti Menghasilkan Customer
              <span className="text-amber-600">.</span>
            </h1>

            <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-600 sm:text-base">
              Banyak bisnis belum mendapatkan hasil maksimal dari iklan karena{' '}
              <span className="font-semibold text-amber-700">
                strategi yang digunakan belum tepat
              </span>
              . Kami membantu Anda menjalankan Meta Ads &amp; Google Ads yang
              lebih terarah agar{' '}
              <span className="font-semibold text-amber-700">
                budget lebih efisien, customer bertambah,
              </span>{' '}
              dan{' '}
              <span className="font-semibold text-amber-700">
                omzet terus meningkat.
              </span>
            </p>

            {/* Price badge */}
           <div className="animate-glow-gold relative mt-5 inline-flex w-fit items-center gap-3 rounded-xl border-2 border-amber-400 bg-[#0F172A] py-2.5 pl-2.5 pr-5">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-amber-400 text-[#0F172A]">
                <LuTag className="h-5 w-5" />
              </span>
              <div className="leading-none">
                <p className="text-[10px] font-medium uppercase tracking-wide text-slate-300">
                  Mulai dari
                </p>
                <p className="mt-0.5 text-xl font-extrabold text-white sm:text-2xl">
                  Rp 490rb{' '}
                  <span className="text-sm font-medium text-slate-400">/bulan</span>
                </p>
              </div>
              {/* Decorative burst accent */}
              <span className="absolute -right-2 -top-3 flex gap-0.5">
                <span className="h-3 w-1 -rotate-12 rounded-full bg-amber-400" />
                <span className="h-4 w-1 rotate-6 rounded-full bg-amber-400" />
                <span className="h-4 w-1 rotate-24 rounded-full bg-amber-400" />
              </span>
            </div>

            <div className="mt-5 flex flex-wrap items-center gap-3">
             {/* Button 1: Konsultasi Gratis - WA */}
                          <a
                            href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 rounded-xl bg-[#8B1E24] px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-red-900/20 transition hover:bg-[#711720] hover:scale-105"
                          >
                            <HiOutlineChatBubbleLeftRight className="h-4 w-4" />
                            Konsultasi Gratis
                          </a>
                           {/* Button 2: Lihat Case Study - WA dengan pesan berbeda */}
                          <button
        onClick={scrollToCaseStudy}
        className="flex items-center gap-2 rounded-xl border border-slate-200 px-5 py-2.5 text-sm font-semibold text-[#0F172A] transition hover:border-slate-300 hover:bg-slate-50 hover:scale-105"
      >
        <FaPlay className="h-3 w-3" />
        Lihat Case Study
      </button>
            </div>

<div className="mt-6 flex flex-wrap items-center gap-3">
  <div className="flex items-center justify-center rounded-xl border border-slate-200 px-4 py-2.5">
    <img src="/meta.jpeg" alt="Meta Business Partner" className="h-12 w-auto object-contain" />
  </div>
  <div className="flex items-center justify-center rounded-xl border border-slate-200 px-4 py-2.5">
    <img src="/google-partner.jpeg" alt="Google Partner" className="h-12 w-auto object-contain" />
  </div>
</div>
          </div>

          {/* Right: visual - REPOSITIONED CARDS */}
          <div className="relative mx-auto w-full max-w-sm lg:max-w-none">
            <div className="pointer-events-none absolute -inset-6 rounded-[2.5rem] bg-gradient-to-br from-amber-100/70 via-orange-50/40 to-transparent blur-2xl" />
            <div className="relative aspect-[5/4] w-full overflow-hidden rounded-[2rem] lg:aspect-[4/3.2]">
              <img
                src="/hero2.png"
                alt="Klien SriDesain mengecek performa campaign iklan"
                className="h-full w-full object-cover"
                style={{
                  maskImage:
                    'radial-gradient(ellipse 100% 100% at center, black 62%, transparent 100%)',
                  WebkitMaskImage:
                    'radial-gradient(ellipse 100% 100% at center, black 62%, transparent 100%)',
                }}
              />
            </div>

            {/* Card 1: WhatsApp - Pindah ke kiri bawah */}
            <StatCard className="bottom-2 left-0 -translate-x-2 px-4 py-3 sm:-translate-x-4">
              <div className="flex items-center gap-2">
                <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-green-500">
                  <FaWhatsapp className="h-4 w-4 text-white" />
                </span>
                <span className="text-xs font-medium text-[#0F172A]">WhatsApp</span>
                <span className="ml-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white">
                  23
                </span>
              </div>
              <p className="mt-1.5 text-lg font-bold text-[#0F172A]">
                23 <span className="text-xs font-semibold text-green-600">Chat Baru</span>
              </p>
              <p className="text-[10px] text-slate-500">Potensial Customer</p>
            </StatCard>

            {/* Card 2: Campaign Performance - Pindah ke kiri atas */}
            <StatCard className="left-0 top-4 -translate-x-2 px-4 py-3 sm:-translate-x-4">
              <div className="flex items-center gap-2">
                <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-blue-500">
                  <LuChartBar className="h-4 w-4 text-white" />
                </span>
                <span className="text-xs font-medium text-[#0F172A]">Campaign Performance</span>
              </div>
              <div className="mt-2 space-y-1.5">
                <div className="flex items-center justify-between gap-6">
                  <span className="text-[10px] text-slate-500">CTR</span>
                  <span className="flex items-center gap-1 text-sm font-semibold text-[#0F172A]">
                    2.85% <LuArrowUpRight className="h-3 w-3 text-green-600" />
                  </span>
                </div>
                <div className="flex items-center justify-between gap-6">
                  <span className="text-[10px] text-slate-500">CPC</span>
                  <span className="flex items-center gap-1 text-sm font-semibold text-[#0F172A]">
                    Rp 1.320 <LuArrowDownRight className="h-3 w-3 text-green-600" />
                  </span>
                </div>
              </div>
              <p className="mt-1.5 text-[10px] text-slate-400">vs last 30 days</p>
            </StatCard>

            {/* Card 3: Revenue Growth - Pindah ke kanan bawah */}
            <StatCard className="bottom-2 right-0 translate-x-1 px-4 py-3 sm:translate-x-4">
              <div className="flex items-center gap-2">
                <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-amber-400">
                  <MdAttachMoney className="h-4 w-4 text-[#0F172A]" />
                </span>
                <span className="text-xs font-medium text-[#0F172A]">Revenue Growth</span>
              </div>
              <p className="mt-1.5 flex items-center gap-1 text-lg font-bold text-green-600">
                <LuTrendingUp className="h-4 w-4" /> +42%
              </p>
              <p className="text-[10px] text-slate-400">vs last 30 days</p>
            </StatCard>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section1;